module.exports = {
  API_BASE_URL: "https://jt-server.onrender.com" || "http://localhost:8000",
};
